import EmptyState from "@/components/EmptyState.vue";
import HeaderRelease from "@/components/HeaderRelease.vue";
import ListDefault from "@/components/ListDefault.vue";
import TextLink from "@/components/TextLink.vue";
import ThreeOptionsListNotifications from "@/components/ThreeOptionsListNotifications.vue";
import Request from "@/ts/Request";
import Util from "@/ts/Util";
import moment from "moment";
import HeaderColor from "orders-module/src/components/HeaderColor.vue";
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    HeaderRelease,
    ListDefault,
    ThreeOptionsListNotifications,
    TextLink,
    EmptyState,
    HeaderColor,
  },
})
export default class Notifications extends Vue {
  currentNotifications: any = JSON.parse(
    sessionStorage.getItem("CURRENT_NOTIFICATIONS") || "[]"
  );
  events: object[] = [];
  pendentNotifications = 0;
  backButton: any = {
    show: true,
    callback: this.goBack,
  };
  cameFromConfirmCode = JSON.parse(
    sessionStorage.getItem("CAME_FROM_CONFIRM_CODE") || "false"
  );

  beforeCreate() {
    Util.getUserNotifications((response: any) => {
      sessionStorage.setItem("CURRENT_NOTIFICATIONS", JSON.stringify(response));
      this.currentNotifications = response;
    });
  }

  mounted() {
    Util.setBackButtonBehavior(this.goBack);
    this.getEvents();
  }

  goToNotification(notificationId: any) {
    const req = new Request();

    //let clickedNotification : any =  this.currentNotifications.filter(((notifcation: any) => notifcation.id == notificationId));
    const clickedNotification = this.currentNotifications.find(
      (surv: any) => surv.id == notificationId
    );

    if (clickedNotification.origin == "survey") {
      sessionStorage.setItem("TITLE_SURVEY", clickedNotification.description);
      sessionStorage.setItem("CURRENT_SURVEY", notificationId);
      this.$router.push("Survey");
    } else if (clickedNotification.origin === "gen_api_external") {
      if (clickedNotification.status == "P") {
        req.body = {
          ID: clickedNotification.id,
          NRORG: sessionStorage.getItem("NRORG"),
          USER_ID: sessionStorage.getItem("USER_ID"),
          TOKEN: sessionStorage.getItem("TOKEN"),
        };
        req.route = "setNotificationAsRead";
        req.callbackSuccess = () => {
          sessionStorage.setItem("CURRENT_REPORT", clickedNotification.id);

          Util.getUserReports((response: any) => {
            sessionStorage.setItem("CURRENT_REPORTS", JSON.stringify(response));
            if (clickedNotification.category == 1) {
              this.$router.push("ReportsDetailsEvent");
            } else this.$router.push("ReportsDetails");
          });
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.showLoader = true;
        req.send();
      } else {
        sessionStorage.setItem("CURRENT_REPORT", clickedNotification.id);

        Util.getUserReports((response: any) => {
          sessionStorage.setItem("CURRENT_REPORTS", JSON.stringify(response));
          if (clickedNotification.category == 1) {
            this.$router.push("ReportsDetailsEvent");
          } else this.$router.push("ReportsDetails");
        });
      }
    } else if (clickedNotification.origin === "Evt_EventFavorite") {
      const id = clickedNotification.externalId;
      const event = this.events.find((event: any) => event.id == id);

      if (clickedNotification.status == "P") {
        req.body = {
          ID: clickedNotification.id,
          NRORG: sessionStorage.getItem("NRORG"),
          USER_ID: sessionStorage.getItem("USER_ID"),
          TOKEN: sessionStorage.getItem("TOKEN"),
        };
        req.route = "setNotificationAsRead";
        req.callbackSuccess = () => {
          if (event) {
            sessionStorage.setItem("EVENT", JSON.stringify(event));
            sessionStorage.setItem("EVENTS", JSON.stringify(this.events));
            sessionStorage.setItem("SELECTED_EVENT", JSON.stringify(id));

            this.$router.push("EventDetails");
          }
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.showLoader = true;
        req.send();
      } else if (event) {
        sessionStorage.setItem("EVENT", JSON.stringify(event));
        sessionStorage.setItem("EVENTS", JSON.stringify(this.events));
        sessionStorage.setItem("SELECTED_EVENT", JSON.stringify(id));

        this.$router.push("EventDetails");
      }
    } else if (clickedNotification.origin === "Order_Orderbackend") {
      const id = clickedNotification.externalId;
      const event = this.events.find((event: any) => event.id == id);

      if (clickedNotification.status == "P") {
        const idsNotification: any = this.currentNotifications.map(
          (notifcation: any) => {
            if (notifcation.status == "P") {
              return notifcation.id;
            }
          }
        );

        req.body = {
          ID: clickedNotification.id,
          ARRAY_ID_NOTIFICATIONS: idsNotification,
          NRORG: sessionStorage.getItem("NRORG"),
          USER_ID: sessionStorage.getItem("USER_ID"),
          TOKEN: sessionStorage.getItem("TOKEN"),
        };
        req.route = "setNotificationAsRead";
        req.callbackSuccess = () => {
          if (event) {
            sessionStorage.setItem("EVENT", JSON.stringify(event));
            sessionStorage.setItem("EVENTS", JSON.stringify(this.events));
            sessionStorage.setItem("SELECTED_EVENT", JSON.stringify(id));

            this.$router.push("EventDetails");
          }
        };
        req.callbackError = function (error: any) {
          console.log(error);
        };
        req.showLoader = true;
        req.send();

        sessionStorage.setItem("USER_HAS_NOTIFICATIONS", "false");
      }
    }

    // PREPARED FOR TYPE & ORDER
    // if (clickedNotification[0].type == 'survey') {
    //     sessionStorage.setItem('CURRENT_SURVEY', clickedNotification[0].ref_id);
    //     this.$router.push('Survey');
    // }
    // } else if (clickedNotification[0].type == 'order') {
    //     sessionStorage.setItem('ORDER_ID', clickedNotification[0].ref_id+'');
    //     this.$router.push('ExtratoPedido');
    // }
  }

  getEvents() {
    try {
      const self = this;
      const req = new Request();
      req.body = {
        NRORG: sessionStorage.getItem("NRORG"),
        TOKEN: sessionStorage.getItem("TOKEN"),
        DATE: sessionStorage.getItem("SELECTED_DATE"),
        STRUCTURES: sessionStorage.getItem("SELECTED_STRUCTURES") || "[]",
        CATEGORIES: sessionStorage.getItem("EVENT_CATEGORIES") || "[]",
        TAGS: sessionStorage.getItem("SELECTED_EVENT_TAGS") || "[]",
        USER_ID: sessionStorage.getItem("USER_ID"),
      };
      req.route = "getEventsByOrg";
      req.callbackSuccess = function (response: any) {
        const events = response.events;
        self.events = events;
      };
      req.callbackError = function (error: any) {
        console.log(error);
      };
      req.blockTouchEvents = false;
      req.send();
    } catch (e) {
      console.log(e);
    }
  }
  // subtract colocado como correção temporaria devido a horário errado no servidor
  formatDateTime(date: any) {
    const stringDate = date.date ? date.date : date;
    const momentDate: any = moment(stringDate).subtract(1, "hours");
    return momentDate.lang("pt-br").format("DD/MM - HH:mm");
  }

  formatTime(date: any) {
    const stringDate = date.date ? date.date : date;
    const momentDate: any = moment(stringDate).subtract(1, "hours");
    return momentDate.lang("pt-br").format("HH:mm");
  }

  goBack() {
    if (this.cameFromConfirmCode) {
      sessionStorage.setItem("CAME_FROM_CONFIRM_CODE", "false");
      this.$router.go(-2);
    } else {
      this.$router.go(-1);
    }
  }
}
